import Moment from 'moment';

export const formatNbLinkedAccounts = (nbLinkedAgents, maxNbLinkedAgents) => `${nbLinkedAgents} out of ${maxNbLinkedAgents}`;
export const formatDate = value => value ? Moment(value).utc().format(window.env.dateFormat) : '';
export const formatDateUtcToLocal = value => value ? Moment(value).local().format(window.env.dateFormatLocalTime) : '';
export const formatDateUtcToLocalDate = value => value ? Moment(value).local().format(window.env.dateFormatLocalDate) : '';